import axios from 'axios' //引入axios
import router from "@/router"
import {useUserStore} from '@/store/login'
import { getToken } from '@/utils/auth'
import message from './message'
const requests = axios.create({
    baseURL: process.env.NODE_ENV === 'production' ? "https://jyj.huaihua.gov.cn/baoming/api/index.php/" : "/api",
    timeout: 15000
})

requests.interceptors.request.use((config)=>{
    const store= useUserStore()
    if (getToken() && store.isLogin) {
        config.headers['token'] = getToken()
    }
    // if(process.env.NODE_ENV !== 'production') {
    //     config.headers['token'] = 'd2585fbb3c25eee17e2b3ba06a9632eb'
    // }
    config.headers['platform'] = 1
    config.data = {
        ...config.data,
        acid: store.acid,
        platform: 1
    }
    return {
        ...config
    }
})

//响应拦截器
requests.interceptors.response.use((res) =>{
    const store =  useUserStore()
    let data = res.data
    if (!data.rs) {
        let msg = data.message || '服务器正忙！'
        if(typeof(data.status) !== 'undefined' && 508 == data.status) {
            message('error',msg);
            setTimeout(function() {
                window.location.href = 'https://jyj.huaihua.gov.cn/baoming/pc?aci=' + store.acid;
            }, 1000);
            return;
        }
        if (data.status === 505) {
            router.push('/login')
            store.loginOut()
        }
        alert(msg)
        return Promise.reject(new Error(msg))
    }
    return data
},(error) =>{
    //服务器响应失败的回调函数
    message('error',error)
    return Promise.reject(new Error('Faile'))
})

export default requests